import * as Constants from "../utils/Constants";
import * as actionConstants from '../redux/constants/action-types';

import HelperFunctions from "../utils/HelperFunctions";
import React from "react";
import formConverter from "../utils/formConverter";

export function middleware({ dispatch }) {
  return function (next) {
    return function (action) {
      if (
        action.type ===
        actionConstants.MARKETINGPLAYCONFIGURATION.LOAD_MARKETING_PLAY_LOOKUP
      ) {
        let MarketingPlayLookupArray = [
          {
            label: "Select Marketing Play",
            value: 0,
          },
        ];
        action.payload.forEach(function (item, index) {
          let temp = {};
          temp["label"] = item.name;
          temp["value"] = item.marketingPlayLookupId;

          MarketingPlayLookupArray.push(temp);
        });

        action.payload = MarketingPlayLookupArray;
      }

      if (
        action.type ===
        actionConstants.MARKETINGPLAYCONFIGURATION.GET_ALL_SCHEDULES_BY_ClIENTID
      ) {
        let allSchedulesByClientID = [
          {
            label: "Select Schedule",
            value: 0,
          },
        ];
        action.payload.forEach(function (item, index) {
          let temp = {};
          temp["label"] = item.scheduleName;
          temp["value"] = item.scheduleId;

          allSchedulesByClientID.push(temp);
        });

        action.payload = allSchedulesByClientID;
      }

      if (
        action.type ===
        actionConstants.MARKETINGPLAYCONFIGURATION
          .GET_ALL_TOUCHPOINTS_BY_ClIENTID
      ) {
        let allTouchpointsByClientID = [
          {
            label: "Select a touchpoint",
            value: 0,
          },
        ];
        action.payload.forEach(function (item, index) {
          let temp = {};
          temp["label"] =
            item.playName +
            " | " +
            (item.subtitle != null ? item.subtitle + ": " : "") +
            item.touchPointName;

          allTouchpointsByClientID.push(temp);
        });

        action.payload = allTouchpointsByClientID;
      }

      if (
        action.type ===
        actionConstants.MARKETING_PLAY_REPORTS.GET_REVENUE_BY_CHANNEL
      ) {
        let allRevenueByChannel = [];
        action.payload.forEach(function (item, index) {
          let temp = {};
          temp["label"] = item.channel;
          temp["value"] = Math.ceil(item.revenue);

          allRevenueByChannel.push(temp);
        });

        action.payload = allRevenueByChannel;
      }

      if (
        action.type ===
        actionConstants.MARKETING_PLAY_REPORTS.GET_TOTAL_ADHOC_REVENUE
      ) {
        let totalRevenue = [];

        action.payload.forEach(function (item, index) {
          let cnt = 2;
          if (
            (typeof item.activePlaysRevenue !== "undefined" ||
              item.activePlaysRevenue !== null) &&
            (typeof item.adhocRevenue !== "undefined" ||
              item.adhocRevenue !== null)
          ) {
            for (let index = 0; index < cnt; index++) {
              let temp = {};
              if (index === 0) {
                temp["label"] = "A360 Play Reveue";
                temp["y"] = Math.ceil(item.activePlaysRevenue);
                temp["color"] = "#85C5E6";
                temp["icon"] = "icon-paperplane";
                temp["cssClass"] = "sky-blue";
              } else {
                temp["label"] = "Ad Hoc Revenue";
                temp["y"] = Math.ceil(item.adhocRevenue);
                temp["color"] = "#0C436A";
                temp["icon"] = "icon-email-open";
                temp["cssClass"] = "blue";
              }

              totalRevenue.push(temp);
            }
          }
        });
        action.payload = totalRevenue;
      }
      if (
        action.type ===
        actionConstants.MARKETING_PLAY_REPORTS.GET_AVG_OPEN_EMAIL_RATE
      ) {
        let allAvgEmailOpenRate = [];
        action.payload.forEach(function (item, index) {
          let temp = {};
          let year = item.emailDate.substring(0, 4);
          let month = item.emailDate.substring(5, 7);
          let dateString = Constants.MonthConversion[month] + " " + year;

          temp["label"] = dateString;
          temp["value"] = item.openRate;

          allAvgEmailOpenRate.push(temp);
        });

        action.payload = allAvgEmailOpenRate;
      }

      if (
        action.type === actionConstants.MARKETING_PLAY_REPORTS.GET_PLAYS_REVENUE
      ) {
        let playsRevenue = [];
        action.payload.forEach(function (item, index) {
          let temp = {};

          temp["label"] = item.playName;
          temp["y"] = Math.ceil(item.revenue);
          temp["cssClass"] = item.cssClass;
          temp["icon"] = item.icon;

          playsRevenue.push(temp);
        });

        action.payload = playsRevenue;
      }

      if (
        action.type ===
        actionConstants.MARKETING_PLAY_REPORTS
          .GET_TOUCHPOINTS_WITH_REVENUE_BY_PLAY_ID
      ) {
        let touchpointsRevenue = [];
        action.payload.forEach(function (item, index) {
          let temp = {};
          temp["label"] = item.touchPointName
            ? item.touchPointName
            : item.emailCampaignName;
          temp["y"] = Math.ceil(item.revenue);
          touchpointsRevenue.push(temp);
        });
        action.payload = touchpointsRevenue;
      }

      if (
        action.type ===
        actionConstants.MARKETING_PLAY_REPORTS
          .GET_TOUCHPOINTS_WITH_REVENUE_BY_CLIENT_ID
      ) {
        let touchpointsRevenues = [];
        action.payload.forEach(function (item, index) {
          let temp = {};
          temp["label"] = item.touchPointName
            ? item.touchPointName
            : item.emailCampaignName;
          temp["y"] = Math.ceil(item.revenue);
          temp["playId"] = item.playId;
          temp["sortOrder"] = item.sortOrder;
          touchpointsRevenues.push(temp);
        });
        action.payload = touchpointsRevenues;
      }

      if (
        action.type ===
        actionConstants.MARKETING_PLAY_REPORTS.REVENUE_OVER_TIME_CUMULATIVE
      ) {
        let RevenueCumultive = [];
        action.payload.forEach(function (item, index) {
          let temp = {};
          let year = item.monthDate.substring(0, 4);
          let month = item.monthDate.substring(5, 7);
          let dateString = Constants.MonthConversion[month] + " " + year;
          temp["label"] = dateString;
          temp["value"] = item.revenue;

          RevenueCumultive.push(temp);
        });

        action.payload = RevenueCumultive;
      }

      if (
        action.type ===
          actionConstants.MARKETING_PLAY_REPORTS
            .TOUCHPOINTS_CUMULATIVE_REVENUE_OVER_TIME ||
        action.type ===
          actionConstants.MARKETING_PLAY_REPORTS
            .TOUCHPOINTS_MONTHLY_REVENUE_OVER_TIME
      ) {
        let touchpointsCumulativeRevenueOverTime = [];
        action.payload.forEach(function (item, index) {
          let temp = {};
          let year = item.monthDate.substring(0, 4);
          let month = item.monthDate.substring(5, 7);
          let dateString = Constants.MonthConversion[month] + " " + year;

          temp["label"] = dateString;
          temp["revenue"] = item.revenue;
          temp["touchPointName"] = item.touchPointName;

          touchpointsCumulativeRevenueOverTime.push(temp);
        });

        action.payload = touchpointsCumulativeRevenueOverTime;
      }

      if (
        action.type ===
        actionConstants.MARKETING_PLAY_REPORTS.REVENUE_OVER_TIME_MONTHLY
      ) {
        let RevenueMonthly = [];
        action.payload.forEach(function (item, index) {
          let temp = {};
          let year = item.monthDate.substring(0, 4);
          let month = item.monthDate.substring(5, 7);
          let dateString = Constants.MonthConversion[month] + " " + year;

          temp["label"] = dateString;
          temp["value"] = item.revenue;

          RevenueMonthly.push(temp);
        });

        action.payload = RevenueMonthly;
      }

      if (
        action.type ===
        actionConstants.MARKETING_PLAY_REPORTS.GET_ADHOC_REVENUE_BY_CLIENT_ID
      ) {
        let adHocRevenues = [];
        action.payload.forEach((item) => {
          let temp = {};
          let newDate = null;
          if (item.campaignDate != null) {
            let year = item.campaignDate.substring(0, 4);
            let month = item.campaignDate.substring(5, 7);
            let day = item.campaignDate.substring(8, 10);
            // construct new date object for sorting
            newDate = new Date(
              year,
              parseInt(month) - 1,
              day
            ); /* months 0..11 */
          }

          temp["revenueSort"] = item.revenue;
          temp["dateSort"] = newDate;
          temp["campaignName"] =
            item.campaignName == null ? "N/A" : item.campaignName;
          temp["campaignSubject"] = item.campaignSubject;
          temp["revenue"] = HelperFunctions.formateNumberbyCommas(
            item.revenue,
            0
          );
          temp["campaignDate"] =
            newDate == null
              ? "N/A"
              : newDate.toLocaleString("default", {
                  month: "long",
                }) +
                " " +
                newDate.getDate() +
                ", " +
                newDate.getFullYear();

          adHocRevenues.push(temp);
        });

        action.payload = adHocRevenues;
      }

      if (
        action.type === actionConstants.MARKETING_PLAY_REPORTS.TOP_PLAYS_REVENUE
      ) {
        let topPlaysRevenue = [];
        action.payload.forEach(function (item, index) {
          let temp = {};
          temp["label"] = item.playName;
          temp["value"] = item.revenue;

          topPlaysRevenue.push(temp);
        });

        action.payload = topPlaysRevenue;
      }
      if (
        action.type ===
        actionConstants.MARKETING_PLAY_REPORTS
          .GET_CLIENT_PLAYS_WITH_TOTAL_REVENUE_PLAY_DETAIL
      ) {
        let clientPlayDropdown = [];
        action.payload.forEach(function (item, index) {
          let temp = {};
          temp["label"] = (
            <div
              className={item.cssClass + " select-single-value d-flex"}
            >
              <span className="icon icon-span">
                <i className={item.icon}></i>
              </span>
              <div>
                <p className="icon-label">{item.playName}</p>
                <p className="icon-subtitle">{item.subtitle}</p>
              </div>
            </div>
          );
          temp["value"] = item.playId;
          temp["chipLabel"] = (
            <div
              className={item.cssClass + " selected_label d-flex"}
            >
              <span className="icon icon-span">
                <i className={`item-icon ${item.icon}`}></i>
              </span>
              <div>
                <div className="icon-label">{item.playName}</div>
                <div className="icon-subtitle">{item.subtitle}</div>
              </div>
            </div>
          );
          //Subtitle
          clientPlayDropdown.push(temp);
        });

        action.payload = clientPlayDropdown;
      }
      if (
        action.type === actionConstants.EMAIL_DESIGNER.GET_ALL_TRACKING_PARAMS
      ) {
        let trackingParams = [];
        action.payload.forEach(function (item, index) {
          let temp = {};
          temp["label"] = item.trackingParameterName;
          temp["value"] = item.trackingParameterId;
          temp["TrackingParameterValue"] = item.trackingParameterValue;

          trackingParams.push(temp);
        });

        action.payload = trackingParams;
      }
      if (action.type === actionConstants.EMAIL_DESIGNER.SEED_LIST) {
        let seedList = [];
        action.payload.forEach(function (item, index) {
          let temp = {};
          temp["label"] = item.seedListName;
          temp["value"] = item.seedListId;
          temp["count"] = item.seedListCount;

          seedList.push(temp);
        });

        action.payload = seedList;
      }

      if (action.type === actionConstants.EMAIL_DESIGNER.TEST_EMAIL_LIST) {
        let testEmailList = [{ label: "Select Test Email List", value: 0 }];
        action.payload.forEach(function (item, index) {
          let temp = {};
          temp["label"] = item.testEmailListName;
          temp["value"] = item.testEmailListId;

          testEmailList.push(temp);
        });

        action.payload = testEmailList;
      }

      if (action.type === actionConstants.EMAIL_DESIGNER.SUPPRESION_LIST) {
        let suppressionList = [];
        action.payload.forEach(function (item, index) {
          let temp = {};
          temp["label"] = item.SuppressionListName;
          temp["value"] = item.SuppressionListId;

          suppressionList.push(temp);
        });

        action.payload = suppressionList;
      }

      if (action.type === actionConstants.EMAIL_DESIGNER.GET_FROM_ADDRESSES) {
        let fromAddresses = [];
        action.payload.forEach(function (item, index) {
          let temp = {};
          temp["label"] = item.fromEmailAddress;
          temp["value"] = item.fromEmailAddress;
          temp["IsDefault"] = item.isDefault;

          fromAddresses.push(temp);
        });

        action.payload = fromAddresses;
      }
      if (
        action.type === actionConstants.EMAIL_DESIGNER.GET_REPLY_EMAIL_ADDRESSES
      ) {
        let replyAddresses = [];
        action.payload.forEach(function (item, index) {
          let temp = {};
          temp["label"] = item.replyToEmailAddress;
          temp["value"] = item.replyToEmailAddress;
          temp["IsDefault"] = item.isDefault;

          replyAddresses.push(temp);
        });

        action.payload = replyAddresses;
      }

      if (
        action.type ===
        actionConstants.EMAIL_DESIGNER.TOP_BOTTOM_PERFORMING_SUMMARY
      ) {
        let topBottomPerformingSummary = [];
        action.payload.forEach(function (item, index) {
          topBottomPerformingSummary[item.campaignName] = item.dataCount;
        });

        action.payload = topBottomPerformingSummary;
      }

      if (
        action.type ===
        actionConstants.EMAIL_DESIGNER.REPORT_SUBSCRIBER_TOP_LINKS
      ) {
        let subscriberTopLinks = [];
        action.payload.forEach(function (item, index) {
          subscriberTopLinks[item.clickUrl] = item.dataCount;
        });

        action.payload = subscriberTopLinks;
      }

      if (
        action.type ===
        actionConstants.EMAIL_DESIGNER.REPORT_SUBSCRIBER_MOST_OPENS
      ) {
        let subscriberMostopens = [];
        action.payload.forEach(function (item, index) {
          subscriberMostopens[item.emailAddress] = item.dataCount;
        });

        action.payload = subscriberMostopens;
      }

      if (action.type === actionConstants.EMAIL_DESIGNER.TOUCHPOINT_MAPPING) {
        let touchPointMapping = [{ label: "Select TouchPoint", value: 0 }];
        action.payload.forEach(function (item, index) {
          let temp = {};
          temp["label"] = item.playName + " | " + item.touchPointName;

          touchPointMapping.push(temp);
        });

        action.payload = touchPointMapping;
      }

      

      // if (action.type === actionConstants.EMAIL_DESIGNER.CLIENT_FONTS) {
      //   let Fonts = Constants.EmailDesignerFonts;
      //   action.payload.forEach(function (item, index) {
      //     let temp = {};
      //     temp["name"] = item.name;
      //     temp["fontFamily"] = item.fontFamily;
      //     temp["url"] = item.url;

      //     Fonts.push(temp);
      //   });

      //   action.payload = Fonts;
      // }

      if (
        action.type ===
        actionConstants.FORM_LIBRARY.GET_FORM_TEMPLATES_WITH_DETAILS
      ) {
        let formTemplates = [];
        action.payload.forEach(function (item, index) {
          let temp = item;
          temp.jsonTemplate = formConverter.toBeeCompatibleForm(item);
          formTemplates.push(temp);
        });

        action.payload = formTemplates;
      }
      return next(action);
    };
  };
}
